export default {
  createPlan: 'Crear Plan',
  noModelsAvailable: 'No hay modelos disponibles. Crea el primero o habla con el administrador.',
  search: 'Buscar',
  loading: 'Cargando...',
  noPlansAvailable: 'No hay planes disponibles para este modelo',
  running: 'Ejecutando...',
  headerName: 'Nombre',
  headerBudget: 'Presupuesto ({unit})',
  upTo: 'hasta {value}',
  headerPredicted: '{kpiName} Proyectadas ({unit})',
  headerPeriod: 'Período',
  headerCreated: 'Creado',
  defaultKpiName: 'Ventas',
  defaultCurrency: 'USD',
  sharedWithExternalUsers: 'Compartido con usuarios externos',
  betaOptimizerTooltip: 'Este plan usa el nuevo optimizador (beta)',
  createFromScratch: 'Desde Cero',
  createLastYearActualBudget: 'Año Anterior, Presupuesto Real (Strategy Check)',
  createLastYearSaturationBudget: 'Año Anterior, Presupuesto que alcanza Saturación Total de Diminishing Returns',
  createNextYearBudgetPropagation: 'Año Siguiente, Propagación de Presupuesto Real (Forward Looking)',
  chooseFromScratchDescription: 'Define tú el período, el presupuesto y las restricciones, y deja que el optimizador distribuya la inversión.',
  chooseActualBudgetTitle: 'Presupuesto Real del Año Anterior',
  chooseActualBudgetDescription: 'Optimiza la inversión total de los últimos 12 meses de datos en ese mismo período.',
  chooseSaturationTitle: 'Año Anterior en Saturación',
  chooseSaturationDescription: 'Optimiza el presupuesto con el que cada canal alcanza la saturación total de diminishing returns en los últimos 12 meses.',
  chooseNextYearTitle: 'Propagación de Presupuesto del Año Siguiente',
  chooseNextYearDescription: 'Optimiza el presupuesto que el modelo propaga para el próximo año.',
  chooseTagStrategyCheck: 'Strategy Check',
  chooseTagSaturation: 'Saturación',
  chooseTagForwardLooking: 'Forward Looking',
  createFlexibleDates: 'Fechas Flexibles',
  chooseFlexibleTitle: 'Fechas Flexibles',
  chooseTagFlexible: 'Flexible',
  flexibleSummaryActual: 'Inversión real',
  flexibleSummaryPropagation: 'Propagación de presupuesto',
  flexibleSummaryEmpty: 'Sin datos, suma 0',
  flexibleMonths: '{count} mes | {count} meses',
  flexibleWeeks: '{count} semana | {count} semanas',
  flexibleHintActual: 'Hay inversión real disponible hasta {date}.',
  flexibleHintPropagation: 'La propagación de presupuesto cubre de {from} a {to}.',
  chooseFlexibleDescription: 'Elige cualquier período: su presupuesto suma la inversión real donde el modelo la tiene y la propagación de presupuesto después.',
  flexibleSummaryTotal: 'Presupuesto',
  chooseNeedsMediaSpend: 'Requiere datos de inversión en medios en el reporte del modelo',
  channelMismatchTitle: 'Los canales del modelo cambiaron',
  channelMismatchIntro: 'Los canales de medios de este modelo ya no coinciden con los de este plan, probablemente porque el modelo se actualizó después de crear el plan. Si continúas, el plan usará los canales actuales del modelo.',
  channelMismatchRemoved: 'Canales del plan que ya no existen en el modelo (su inversión se descartará):',
  channelMismatchProceedAnyway: 'Continuar de todos modos',
  channelMismatchCancel: 'Cancelar'
}
